(function () {
console.log("👑 KING SWIPE V7 FINAL SAFE CLICK INIT");

const TOUCH_RATIO = 0.33;
const MOUSE_RATIO = 0.14;
const SPEED = 2800;
const EASE = "cubic-bezier(.22,.8,.22,1)";
const VERTICAL_GUARD = 75;

function bindAll(root = document) {
root.querySelectorAll(".king-slider").forEach(slider => {
if (slider.dataset.kingSwipeBound === "1") return;

const track = slider.querySelector(".king-track");
const slides = Array.from(slider.querySelectorAll(".king-slide"));

if (!track || slides.length < 2) return;

slider.dataset.kingSwipeBound = "1";

const card = slider.closest(".card") || slider.closest(".card-wrapper");
const productLink =
card?.querySelector('a[href*="/products/"]') ||
card?.querySelector("a[href]");

slider.style.overflow = "hidden";
slider.style.touchAction = "pan-y";
slider.style.position = "relative";
slider.style.width = "100%";

track.style.display = "flex";
track.style.flexDirection = "row";
track.style.flexWrap = "nowrap";
track.style.width = `${slides.length * 100}%`;
track.style.height = "100%";
track.style.transform = "translate3d(0,0,0)";
track.style.willChange = "transform";

slides.forEach(slide => {
slide.draggable = false;
slide.addEventListener("dragstart", e => e.preventDefault());

slide.style.position = "relative";
slide.style.display = "block";
slide.style.flex = `0 0 ${100 / slides.length}%`;
slide.style.width = `${100 / slides.length}%`;
slide.style.maxWidth = `${100 / slides.length}%`;
slide.style.minWidth = `${100 / slides.length}%`;
slide.style.height = "100%";
slide.style.objectFit = "cover";
slide.style.objectPosition = "center";
slide.style.pointerEvents = "none";
slide.style.transform = "none";
});

let index = 0;
let startX = 0;
let startY = 0;
let dragging = false;
let didSwipe = false;
let moved = false;
let lockedVertical = false;
let suppressNextClick = false;

function applyPosition(px, animate) {
track.style.transition = animate
? `transform ${SPEED}ms ${EASE}`
: "none";

track.style.transform = `translate3d(${px}px,0,0)`;
}

function currentX() {
return -index * slider.clientWidth;
}

function goTo(i, animate = true) {
index = Math.max(0, Math.min(i, slides.length - 1));
applyPosition(currentX(), animate);
}

function blockClick(e) {
console.log("BLOCK CLICK");
e.preventDefault();
e.stopImmediatePropagation();
e.stopPropagation();
return false;
}

slider.addEventListener("pointerdown", e => {
if (e.target.closest(".king-heart, .king-view-trigger")) return;

dragging = true;
didSwipe = false;
moved = false;
lockedVertical = false;
suppressNextClick = false;

startX = e.clientX;
startY = e.clientY;

track.style.transition = "none";
slider.setPointerCapture?.(e.pointerId);
}, { passive: true });

slider.addEventListener("pointermove", e => {
if (!dragging) return;

const dx = e.clientX - startX;
const dy = e.clientY - startY;

if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
moved = true;
suppressNextClick = true;
}

if (!lockedVertical && Math.abs(dy) > VERTICAL_GUARD && Math.abs(dy) > Math.abs(dx)) {
lockedVertical = true;
dragging = false;
suppressNextClick = true;
goTo(index, true);
return;
}

if (Math.abs(dx) > 6) didSwipe = true;

let nextX = currentX() + dx;

if ((index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0)) {
nextX = currentX() + dx * 0.28;
}

applyPosition(nextX, false);
}, { passive: true });

slider.addEventListener("pointerup", e => {
if (!dragging) return;

dragging = false;

const dx = e.clientX - startX;
const isMouse = e.pointerType === "mouse";
const threshold = slider.clientWidth * (isMouse ? MOUSE_RATIO : TOUCH_RATIO);

if (Math.abs(dx) > threshold) {
suppressNextClick = true;
didSwipe = true;

if (dx < 0) goTo(index + 1, true);
else goTo(index - 1, true);
} else {
goTo(index, true);

if (moved) {
suppressNextClick = true;
}
}
}, { passive: true });

slider.addEventListener("pointercancel", () => {
dragging = false;
suppressNextClick = true;
goTo(index, true);
}, { passive: true });

slider.addEventListener("click", blockClick, true);
if (card) card.addEventListener("click", blockClick, true);

goTo(0, false);
});
}

bindAll();

const mo = new MutationObserver(muts => {
muts.forEach(m => {
m.addedNodes.forEach(n => {
if (n instanceof HTMLElement) bindAll(n);
});
});
});

mo.observe(document.body, { childList: true, subtree: true });

window.addEventListener("pageshow", () => bindAll());
document.addEventListener("shopify:section:load", () => bindAll());

console.log("👑 KING SWIPE V7 FINAL SAFE CLICK READY");
})();